<template>
  <div class="oneTwoWrapper">
    <VHeaderOld></VHeaderOld>
    <div class="contentBody" :class="{'suitIOS':!ISANDROID}">
      <div class="mainWrapperOld" ref="mainRef1">
        <div class="content">
          <p class="title">{{dTitle}}</p>
          <p class="fTitle"><span class="dfrom">{{dFrom}}</span><span class="depart">{{depart}}</span><span
              class="dtime">{{dTime}}</span></p>
          <div class="dContent">
            {{Dontent}}
          </div>
          <div class="videoWrapper">
            <div class="videoContent" @click="playVedio">
              <div class="model" v-if="modelShow"></div>
              <video v-if="!modelShow" class="video" controls="controls" ref="vedioRef">
                <source :src="videoUrl" type="video/mp4">
                <source :src="videoUrl" type="video/ogg">
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import BScroll from "better-scroll";
  import vedioBg from '@/assets/images/vedioBg.png';
  import VHeaderOld from '@/components/VHeaderOld'
  export default {
    name: "One",
    data() {
      return {
        modelShow: true,
        dTitle: 'AR量方来啦',
        dFrom: 'AR与新技术研究项目组（项目）',
        depart: '',
        dTime: '2018-6-8 12:30',
        Dontent: "货物要量体积，尺子不在身边怎么办? 尺子量方后还要计算，真麻烦！没关系, 德邦最新黑科技--AR量方来啦！只要扫一扫"
          + "货物就能量出体积，你说牛不牛！",
        videoUrl: "http://file.deppon.com.cn/DPM_BEI/Resourse/ARLX.mp4",
        videoBgUrl: vedioBg
      };
    },
    created() {
    },
    mounted() {
      this._initialScroll();
    },
    methods: {
      _initialScroll() {
        if (!this.scroll) {
          this.mainWrapper = new BScroll(this.$refs.mainRef1, {
            click: true
          });
        } else {
          this.scroll.refresh();
        }
      },
      playVedio(event) {
        this.modelShow = false;
        let vedio;
        this.$nextTick(() => {
          vedio = this.$refs.vedioRef;
          if (!this.modelShow) {
            if (!vedio.paused) {
              vedio.pause();
            } else {
              vedio.play();
            }
          }
        })
      }
    },
    components: {
      VHeaderOld
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/One.vue